import { gql } from '@apollo/client';

/**
 * GraphQL mutation for deleting community prompts
 */
export const DELETE_COMMUNITY_PROMPT = gql`
  mutation DeleteCommunityPrompt($communityId: ID!, $input: DeleteCommunityPromptInput!) {
    deleteCommunityPrompt(communityId: $communityId, input: $input) {
      success
      message
    }
  }
`;
